import React from "react";
import { Button } from "@material-ui/core";
import { FileCopy } from "@material-ui/icons";
import useStore from "context";
import { useTranslation } from "localization/translation";

export const CopyButton = ({ text }) => {
  const { setSuccessMsg, setErrorMsg } = useStore();
  const translation = useTranslation();
  const value = String(text || "").trim();

  const handleCopy = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (!value) return;

    try {
      await navigator.clipboard.writeText(value);
      setSuccessMsg(translation.copied);
    } catch (error) {
      setErrorMsg(translation.something_went_wrong);
    }
  };

  return (
    <Button
      className="btn-neutral-first mx-1 shadow-none border-0 p-0 d-inline-flex align-items-center justify-content-center"
      style={{ minWidth: 24, width: 24, height: 24 }}
      onClick={handleCopy}
      disabled={!value}
      title={translation.copy}
    >
      <FileCopy style={{ fontSize: 14 }} />
    </Button>
  );
};
